import dayjs from "dayjs"

export function generateWeekDaysFromSavedTimes(currentFormData = {}, userTimezone, savedTimes = {}) {
  const allWeekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
  const updatedFormData = {}

  const savedDayMap = Object.entries(savedTimes).reduce((acc, [key, value]) => {
    if (value.start) {
      const label = dayjs(value.start).tz(userTimezone).format('dddd')
      const normalizedKey = dayjs(value.start).tz(userTimezone).startOf('day').valueOf().toString()
      acc[label] = {
        key: normalizedKey,
        value,
      }
    }
    return acc
  }, {})

  allWeekdays.forEach((label, index) => {
    const monday = dayjs().tz(userTimezone).startOf('week').add(1, 'day')
    const referenceDay = monday.add(index, 'day')
    const timestamp = referenceDay.valueOf().toString()

    const existingFormDataForDay = currentFormData[timestamp]

    // Condition to preserve user's unchecked state
    // If the day exists in currentFormData and checked is explicitly false,
    // we respect that choice, regardless of savedTimes.
    if (existingFormDataForDay && existingFormDataForDay.checked === false) {
      updatedFormData[timestamp] = {
        start: existingFormDataForDay.start || '',
        end: existingFormDataForDay.end || '',
        checked: false,
        dayString: label.toLowerCase()
      };
    }
    // If not explicitly unchecked by the user, then proceed with saved times or default
    else if (savedDayMap[label]) {
      const { value } = savedDayMap[label]
      updatedFormData[timestamp] = {
        start: value.start,
        end: value.end,
        checked: value.checked ?? true,
        dayString: label.toLowerCase()
      }
    } else {
      // If no saved times and not explicitly unchecked,
      updatedFormData[timestamp] = {
        start: existingFormDataForDay?.start || '',
        end: existingFormDataForDay?.end || '',
        checked: existingFormDataForDay?.checked || false,
        dayString: label.toLowerCase()
      }
    }
  })
  return updatedFormData
}